import { fromJS, Map, List } from "immutable";
import { combineReducers } from "redux";
import { FETCH_SUBSCRIPTION_PLANS_SUCCESS, SWITCH_IS_MONTHLY } from "~/store/action_types";

const plans = (state = Map(), action = {}) => {
  switch (action.type) {
    case FETCH_SUBSCRIPTION_PLANS_SUCCESS:
      if (!action.response || !action.response.entities || !action.response.entities.subscription_plans) {
        return state;
      }
      return state.merge(fromJS(action.response.entities.subscription_plans));
    default:
      return state;
  }
};

const plansNames = (state = List(), action = {}) => {
  switch (action.type) {
    case FETCH_SUBSCRIPTION_PLANS_SUCCESS: {
      if (!action.response || !action.response.result || !action.response.result || !action.response.result.plans) {
        return state;
      }

      return state.merge(fromJS(action.response.result.plans));
    }
    default:
      return state;
  }
};

const pricingModel = (state = Map(), action = {}) => {
  switch (action.type) {
    case FETCH_SUBSCRIPTION_PLANS_SUCCESS: {
      if (!action.response || !action.response.entities || !action.response.entities.pricing_model) {
        return state;
      }

      return state.merge(fromJS(action.response.entities.pricing_model));
    }
    default:
      return state;
  }
};

const pricingModelName = (state = ``, action = {}) => {
  switch (action.type) {
    case FETCH_SUBSCRIPTION_PLANS_SUCCESS:
      if (!action.response || !action.response.result || !action.response.result.pricing_model) {
        return state;
      }

      return action.response.result.pricing_model;
    default:
      return state;
  }
};

const isMonthly = (state = false, action = {}) => {
  switch (action.type) {
    case SWITCH_IS_MONTHLY:
      return action.isMonthly;
    default:
      return state;
  }
};

const isSelectedAnnuallyFromPicker = (state = false, action = {}) => {
  switch (action.type) {
    case SWITCH_IS_MONTHLY:
      return !action.isMonthly;
    default:
      return state;
  }
};

export default combineReducers({
  plans,
  plansNames,
  pricingModel,
  pricingModelName,
  isMonthly,
  isSelectedAnnuallyFromPicker,
});
